module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "绑定手机号码"
    }
  }), _vm._v(" "), _c('div', [_c('group', [_c('x-input', {
    attrs: {
      "title": "手机号",
      "name": "mobile",
      "placeholder": "请输入手机号码",
      "keyboard": "number",
      "is-type": "china-mobile"
    },
    model: {
      value: (_vm.mobileNumber),
      callback: function($$v) {
        _vm.mobileNumber = $$v
      },
      expression: "mobileNumber"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "验证码",
      "name": "smsCode",
      "keyboard": "number",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.smsCode),
      callback: function($$v) {
        _vm.smsCode = $$v
      },
      expression: "smsCode"
    }
  }, [(_vm.countingNumber) ? _c('x-button', {
    attrs: {
      "slot": "right",
      "type": "primary",
      "disabled": "",
      "mini": ""
    },
    slot: "right"
  }, [_vm._v("发送 (" + _vm._s(_vm.countingNumber) + ")")]) : _c('x-button', {
    attrs: {
      "slot": "right",
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sendSMSCode($event)
      }
    },
    slot: "right"
  }, [_vm._v("发送")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.mobileNumber || !_vm.smsCode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.bindMobileNumber($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46d5120a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/bindMobileNumber.vue
// module id = 554
// module chunks = 0